Billy.image = function(path) {
    return ENV.releasePath + 'assets/images/' + path
}

Billy.flagIcon = function(icon) {
    return ENV.iconBaseUrl + 'silk-flags/' + icon + '.png'
}
